<style scoped>

  #fullscreen-loader {
    height: 100vh;
    background-color: #D4D4D4;
  }

  .ui.main.container {
    min-height: 100vh !important;
    width: 95% !important;
    padding-top: 70px !important;
  }

  .ui.menu .item img.logo {
    margin-right: 15px;
    height: 12px;
    width: 70px;
  }

  .menu-icon {
    margin-left: 8px !important;
  }

  .wireframe {
    margin-top: 2em;
  }

  .ui.footer.segment {
    margin: 5em 0em 0em;
    padding: 5em 0em;
  }

</style>

<template>

  <div>    

    <top-menu v-if="!loading" @onLogout="showLogoutDialog()" /> 

    <div v-if="loading" id="fullscreen-loader" class="ui basic segment">
      <div class="ui active inverted dimmer">
        <div class="ui massive orange loader"></div>
      </div>
    </div>    

    <div v-if="!loading" id="app-container" class="app-main-container app-bg animated fadeIn">  

      <side-menu @onLogout="showLogoutDialog()" />                 

      <div class="ui main container" @click="onContainerClick()">
        <transition appear enter-active-class="animated fadeIn" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>    

      <div class="ui inverted vertical footer segment">
        <div class="ui container">
          <p>{{ appName }}</p>
          <p>© {{ new Date().getFullYear() }} - Simavet Diagnóstico Veterinário LTDA. Todos os direitos reservados.</p>
          <p>Desenvolvido com <i class="coffee brown icon"></i> e <i class="heart red icon"></i>por 
            &nbsp;<a href="https://soulsys.tech" style="color: #21ABA8;" target="_blank"><strong>soul</strong>sys</a>
          </p>
        </div>
      </div>

      <div id="logout-dialog" class="ui tiny modal logout-modal">
        <div class="ui header">
          Logout
        </div>
        <div class="content">
          <p>Deseja realmente sair ?</p>
        </div>
        <div class="actions">
          <button class="ui cancel basic button">
            <i class="remove icon"></i>
            Não
          </button>
          <button class="ui red basic button" @click="onConfirmLogout()">
            <i class="checkmark icon"></i>
            Sim
          </button>
        </div>
      </div>

    </div>

  </div>

</template>

<script>

  import io from "socket.io-client"
  import pkg from "../../package.json"
  import AuthService from "@/services/auth-service"
  import BookmarkService from "@/services/bookmark-service"
  import clearStore from "@/store/clear-store"
  import { SideMenu, TopMenu } from "@/components"  

  export default {

    name: "LayoutPage",

    data() {
      return {
        authService: new AuthService(),
        bookmarkService: new BookmarkService(),
        loading: true,
        unsubscribe: null,
      }
    },

    components: {
      SideMenu,
      TopMenu,
    },

    computed: {

      appName() {
        return `${process.env.VUE_APP_NAME} - v${pkg.version}`
      },
    },

    created() {
      this.setAppTitle()
      this.handleSockets()
      this.unsubscribe = this.authService.onAuthStateChanged(this.onAuthStateChanged)
    },

    beforeDestroy() {

      this.unsubscribe()
      
      $(".logout-modal").remove()
    },

    methods: {

      setAppTitle() {

        let title = "Portal Simavet"

        if (this.$isStaging)
          title += " | TESTE"

        document.title = title  
      },

      handleSockets() {

        const url = process.env.VUE_APP_ENV == "development" || window.location.href.indexOf("localhost") > -1 ? process.env.VUE_APP_API_SOCKET_URL : null
        const socket = io(url)

        socket.on("CERT_STATUS", (data) => {
          this.$reloadDataTables(["cert-complement-requests", "certs", "daily-certs"])
        })

        socket.on("EXAM_REQUEST_STATUS", (data) => {
          this.$reloadDataTables(["exam-requests"])
        })

        socket.on("EMPLOYEE_INVOICE_STATUS", (data) => {
          this.$reloadDataTables(["employee-invoices"])
        })
      },

      async onAuthStateChanged(user) {

        if (!user) {
          if (this.$store.state.auth.loggingOut) {
            clearStore()
            return location.reload()
          } else {
            return this.$router.push("/login")
          }  
        }

        try {

          await this.authService.loadCurrentUser(user)
          await this.bookmarkService.loadCurrentUserBookmarks()

          this.loading = false
          
        } catch (error) {
          this.$errorHandler(error)
        }
      },

      // Just to hide dropdowns on mobile
      onContainerClick() {},

      navTo(route) {

        $("#sidebar").sidebar("hide")

        this.$router.push(route)
      },

      showLogoutDialog() {

        $("#sidebar").sidebar("hide")

        $("#logout-dialog").modal("show")
      },

      async onConfirmLogout() {

        if (this.$store.state.auth.loggingOut)
          return        

        try {

          $("#logout-dialog").modal("hide")          

          setTimeout(async () => {

            this.loading = true

            this.$store.commit("auth/setLoggingOut", true)

            await this.authService.logout()

          }, 600)   

        } catch (error) {
          this.$errorHandler(error)
        }
      },
    },
  }

</script>
